import React from 'react'
import type { HeaderRowConfig } from '@ztechapps/webui.data-tools'
import { MenuHeaderCell } from '@ztechapps/webui.data-tools'

export const ListHeader = (props: HeaderRowConfig) => {
  return (
    <>
      <MenuHeaderCell />

      {/* Empty cell for expand/collapse toggle column */}
      <th style={{ width: '30px' }} />

      {props._renderDataHeaderCell()}
    </>
  )
}
